import React, { useEffect, useState } from 'react';

export default function Proxy() {
  const [error, setError] = useState<string | null>(null);
  const [status, setStatus] = useState<string>('');

  useEffect(() => {
    const run = async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const url = params.get('url');
        if (!url) {
          setError('Missing url parameter');
          return;
        }
        const resp = await fetch(url, { mode: 'cors' });
        const blob = await resp.blob();
        const contentType = resp.headers.get('Content-Type') || 'application/octet-stream';
        // stream blob to the browser
        const reader = new FileReader();
        reader.onload = () => {
          const arrayBuffer = reader.result as ArrayBuffer;
          const bytes = new Uint8Array(arrayBuffer);
          // write to document; in practice, this component is only for debugging
          setStatus(`Loaded ${bytes.byteLength} bytes (${contentType})`);
        };
        reader.readAsArrayBuffer(blob);
      } catch (e: any) {
        setError(e?.message || String(e));
      }
    };
    run();
  }, []);

  return (
    <div style={{ color: 'white', padding: 12 }}>
      <div>Proxy debug</div>
      {error ? <div>error: {error}</div> : <div>{status}</div>}
    </div>
  );
}



